var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getBasicImageObject } from './get-basic-image-object';
export var getImageWithThumbnailObject = function (image, thumbnail) {
    if (image === void 0) { image = {}; }
    if (thumbnail === void 0) { thumbnail = {}; }
    return (__assign(__assign({}, getBasicImageObject(image)), (thumbnail ? { thumbnail: getBasicImageObject(thumbnail, false) } : {})));
};
